import React from "react";
import { Tr, Td, Flex, Text, Button } from "@chakra-ui/react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/modal";
import { useTransactionFunction } from "../../Transaction";
import Icon from "../../Icon";
import CoinAmount from "../../CoinAmount";
import TokenTable from "../../TokenTable";
import { LiquityStoreState, TroveMappings } from "@liquity/lib-base";
import { useLiquity } from "../../../Hooks/LiquityContext";
import { format } from "../../../Utils/number";
import tokenData from "../../../TokenData";
import { useLiquitySelector } from "@liquity/lib-react";

const selector = ({ collateralSurplusBalance }: LiquityStoreState) => ({
  collateralSurplusBalance
});

export type ClaimCollateralSurplusProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ClaimCollateralSurplus: React.FC<ClaimCollateralSurplusProps> = ({ isOpen, onClose }) => {
  const { liquity } = useLiquity();
  const { collateralSurplusBalance } = useLiquitySelector(selector);

  const rewardTokens = tokenData.filter(({ address }) =>
    Object.keys(collateralSurplusBalance).includes(address)
  );

  const [sendTransaction] = useTransactionFunction(
    "claim-surplus",
    liquity.send.claimCollateralSurplus.bind(liquity.send)
  );

  const onSubmit = (): void => {
    sendTransaction();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="2xl" pb={1}>
          Claim Collateral Surplus
        </ModalHeader>

        <ModalBody px={0}>
          <TokenTable headers={["token", "amount"]} width={5}>
            <>
              {rewardTokens.map(({ token, address }) => (
                <Tr key={token}>
                  <Td pb={0} pt={4}>
                    <Flex align="center">
                      <Icon iconName={token} h={5} w={5} />
                      <Text ml={3}>{token}</Text>
                    </Flex>
                  </Td>
                  {[...new Array(3)].map(_ => (
                    <Td pb={0} pt={4} />
                  ))}
                  <Td pb={0} pt={4}>
                    <CoinAmount token={token} amount={format(collateralSurplusBalance[address])} />
                  </Td>
                </Tr>
              ))}
            </>
          </TokenTable>
        </ModalBody>

        <ModalFooter justifyContent="flex-start" mt={2}>
          <Button variant="primary" mr={6} onClick={onSubmit}>
            Claim
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ClaimCollateralSurplus;
